import React from 'react'
import { Container } from 'react-bootstrap'


function FooterSection() {
  return (
    <footer className='footer-section' style={{ backgroundColor: "rgb(2, 21, 43)", color: "#F5F5F5", padding: '2rem', marginTop: '3rem' }}>
        <Container>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <h5>JJS Consultancy</h5>
                    <p>Empowering Your Business for Future Growth</p>
                </div>
                <div>
                    <p>Home | About | Services</p>
                    <p>Follow us: [Social Media Links]</p>
                </div>
            </div>
        </Container>
  </footer>
  )
}

export default FooterSection